<template>
  <div style="border: 1px solid #333; padding: 1rem; margin-bottom: 1rem; margin: 1rem -1rem;">
    <p>
      <strong>C.</strong>
      {{ $t('contract.working_hours.option_c.paragraphs.first') }}
    </p>

    <p>{{ $t('contract.working_hours.option_c.label') }}</p>

    <ul>
      <li v-if="days.monday">{{ $t('contract.working_hours.days.monday') }}</li>
      <li v-if="days.tuesday">{{ $t('contract.working_hours.days.tuesday') }}</li>
      <li v-if="days.wednesday">{{ $t('contract.working_hours.days.wednesday') }}</li>
      <li v-if="days.thursday">{{ $t('contract.working_hours.days.thursday') }}</li>
      <li v-if="days.friday">{{ $t('contract.working_hours.days.friday') }}</li>
      <li v-if="days.saturday">{{ $t('contract.working_hours.days.saturday') }}</li>
    </ul>
  </div>
</template>

<script>
export default {
  computed: {
    options() {
      return this.$store.state.contract.workingHours.options;
    },
    days() {
      return this.$store.state.contract.workingHours.C.days;
    }
  }
};
</script>
